import { Injectable } from "@angular/core";
import { ISelectedLine } from "app/_models/ISelectedLine";
import { ILine } from "app/_models/ILine";
import { CommunicationService } from "app/_services/communication.service";

@Injectable({ providedIn: 'root' })
export class SelectExpandController {
  constructor(private communicationService: CommunicationService) { }

  reExpandRows(expandedRows: number[], lines: ILine[]): ILine[] {
    for (var i = 0; i < lines.length; i++) {
      for (var j = 0; j < expandedRows.length; j++) {
        if (Number(lines[i].rowId) == expandedRows[j]) lines[i].expanded = true;
      }
    }

    return lines;
  }

  reSelectRows(selectedLines: ISelectedLine[], lines: ILine[]): ILine[] {
    for (var i = 0; i < lines.length; i++) {
      for (var j = 0; j < selectedLines.length; j++) {
        if (lines[i].rowId == selectedLines[j].id) lines[i].selected = true;
      }
    }

    return lines;
  }

  shiftSelect(selectedLines: ISelectedLine[], lines: ILine[]): { selectedLines: ISelectedLine[], lines: ILine[] } {
    if (selectedLines.length == 2) {
      //if user is shift selected from bottom to top just swap the ids so everything still selects
      if (selectedLines[0].lineNumber > selectedLines[1].lineNumber) {
        let temp = selectedLines[1];
        selectedLines[1] = selectedLines[0];
        selectedLines[0] = temp;
      }

      lines.forEach(line => {
        if (line.lineNumber > selectedLines[0].lineNumber && line.lineNumber < selectedLines[selectedLines.length-1].lineNumber) {
          line.selected = true;
          selectedLines.splice(selectedLines.length - 1, 0, { id: line.rowId, lineData: line.list, lineNumber: line.lineNumber });        
        }
      })
    }

    return { selectedLines, lines };
  }

  unselectRow(selectedLines: ISelectedLine[], rowData: ILine): ISelectedLine[] {
    let index = selectedLines.findIndex(val => val.id === rowData.rowId);
    if (index !== -1) selectedLines.splice(index, 1);
    return selectedLines;
  }

  selectLines(selectedLine: ILine, shiftSelect: boolean, controlSelect: boolean, selectedLines: ISelectedLine[], lines: ILine[], previousViewName: string, currentViewName: string, detailGrid: boolean): { selectedLines: ISelectedLine[], lines: ILine[], currentViewName: string } {
    if (shiftSelect) {
      if (selectedLine.selected) {
        if (previousViewName != currentViewName && detailGrid) selectedLines = [];//if child table is active, reset

        selectedLines.push({ id: selectedLine.rowId, lineData: selectedLine.list, lineNumber: selectedLine.lineNumber });
        let result = this.shiftSelect(selectedLines, lines);
        selectedLines = result.selectedLines;
        lines = result.lines;

        if (selectedLines.length == 2 && detailGrid) {
          this.communicationService.deselectParentLines();
          previousViewName = currentViewName;//updates viewname for subsequent checks   
        }
      }
    } else if (controlSelect) {
      if (selectedLine.selected) {
        selectedLines.push({ id: selectedLine.rowId, lineData: selectedLine.list, lineNumber: selectedLine.lineNumber });
        selectedLines.forEach(selectedLine => {
          lines.forEach(line => { if (line.rowId == selectedLine.id) line.selected = true; })
        })

        if (detailGrid) {
          this.communicationService.deselectParentLines();
          previousViewName = currentViewName;//updates viewname for subsequent checks    
        }
      } else selectedLines = this.unselectRow(selectedLines, selectedLine);
    } else if (selectedLine.selected) {
      selectedLines = [];//if child table is active, reset              
      selectedLines.push({ id: selectedLine.rowId, lineData: selectedLine.list, lineNumber: selectedLine.lineNumber });
      lines.forEach(line => { line.rowId == selectedLine.rowId ? line.selected = true : line.selected = false });
      if (detailGrid) {
        this.communicationService.deselectParentLines();
        previousViewName = currentViewName;//updates viewname for subsequent checks  
      }
    } else if (!selectedLine.selected) selectedLines = this.unselectRow(selectedLines, selectedLine);

    return { selectedLines, lines, currentViewName };
  }

  selectAll(lines: ILine[], selectedLines: ISelectedLine[]): { lines: ILine[], selectedLines: ISelectedLine[] } {
    selectedLines = [];
    lines.forEach(line => {
      line.selected = true;
      selectedLines.push({ id: line.rowId, lineData: line.list, lineNumber: line.lineNumber });
    })

    return { lines, selectedLines };
  }

  collapse(expandedLine: ILine, expandedRows: number[], nodeId: string, viewName: string, lines: ILine[]): { expandedLine: ILine, expandedRows: number[], lines: ILine[] } {
    if (expandedLine) {
      expandedLine.expanded = false;
      let index = expandedRows.findIndex(val => val === Number(expandedLine.rowId));
      if (index !== -1) expandedRows.splice(index, 1);
    } else {
      expandedRows = [];
      lines.forEach(line => { line.expanded = false; })
    }

    sessionStorage.removeItem(!viewName ? `${nodeId}|Expanded` : `${nodeId}|Expanded|${viewName}`)
    return { expandedLine, expandedRows, lines };
  }

  expand(expandedLine: ILine, lines: ILine[], expandedRows: number[], viewName: string, nodeId: string): { lines: ILine[], expandedRows: number[], expandedLine: ILine } {    
    if (!viewName) {
      sessionStorage.removeItem('childSortString');
      sessionStorage.removeItem('selectedChildTabIndex');
    }

    if (!expandedLine) {
      lines.forEach(line => {
        line.expanded = true;
        expandedRows.push(Number(line.rowId));
      })

      return { lines, expandedRows, expandedLine };
    }

    if (expandedLine.expanded) {
      let res = this.collapse(expandedLine, expandedRows, nodeId, viewName, lines);
      return { lines: res.lines, expandedRows: res.expandedRows, expandedLine };
    }

    expandedLine.expanded = true;
    expandedRows.push(Number(expandedLine.rowId));
    sessionStorage.setItem(!viewName ? `${nodeId}|Expanded` : `${nodeId}|Expanded|${viewName}`, expandedRows.join(';'))
    return { lines, expandedRows, expandedLine };   
  }
}